import React, { useState } from "react";
import { signInWithEmailAndPassword } from "@firebase/auth";
import { auth } from "../utils/firebaseSecondary";
import "./Login.css";

import { useNavigate } from "react-router-dom";

const Login = () => {
  const [loginEmail, setLoginEmail] = useState("");
  const [loginPasssword, setLoginPassword] = useState("");

  let navigate = useNavigate();

  const login = async () => {
    try {
      const user = await signInWithEmailAndPassword(
        auth,
        loginEmail,
        loginPasssword
      );
      console.log(user);
      navigate("/");
    } catch (err) {
      console.log(err.message);
    }
  };
  return (
    <div
      style={{
        height: "100vh",
        width: "100vw",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div className="white-box">
        <h1>Login</h1>
        <div>
          <input
            className="modal-input"
            placeholder="Email"
            onChange={(e) => {
              setLoginEmail(e.target.value);
            }}
          />
          <input
            className="modal-input"
            type="password"
            placeholder="Password"
            onChange={(e) => {
              setLoginPassword(e.target.value);
            }}
          />
        </div>
        <button className="submit-button" onClick={() => login()}>
          Log In
        </button>
      </div>
    </div>
  );
};

export default Login;
